import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Spinner from '../Spinner';
import ItemModify from '../Form/ItemModify';

@inject('dataSourceStore', 'daqProcessorStore')
@observer
class DataSourceModify extends Component {

  componentWillMount() {
    const { daqProcessorStore } = this.props;
    if (!daqProcessorStore.isLoading && !daqProcessorStore.items.length) daqProcessorStore.fetchItems();
  }

  render() {
    const { dataSourceStore, daqProcessorStore, params } = this.props;

    return (
      <ItemModify
        title='Data Source'
        slug='/daq/data-source'
        store={dataSourceStore}
        itemFields={[
          { label: 'Id', key: 'id', editOnly: true, readOnly: true },
          { label: 'Name', key: 'name', type: 'text' },
          { label: 'Description', key: 'description', type: 'text' },
          { label: 'Provider', key: 'provider', type: 'text' },
          { label: 'Daq Processor', key: 'daq_processor_id', type: 'select', options: daqProcessorStore.items, fields: { label: 'parser', value: 'id' } },
        ]}
        params={params}
        isLoading={daqProcessorStore.isLoading}
      />
    );

  }
}


export default DataSourceModify;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceModify.js